import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  IconButton,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { TrashCanGrid } from 'Components';
import { Add, Shrink, TrashCan } from 'Images';
import React, { ReactNode, useEffect, useState } from 'react';
import { DICTIONARY } from '../../Enum';
import { Dictionary } from '../../Dictionary';
import { useIsDesktop } from 'Hooks';

interface IPaperCard {
  index: number;
  remove: () => void;
  text?: ReactNode;
  isOpen: boolean;
  setCurrentOpenCard: Function;
  noFocus?: boolean;
  children?: ReactNode;
}

export const PaperCard: React.FC<IPaperCard> = (props) => {
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  const style = isOpen
    ? {
        minHeight: 0,
        height: 0,
        padding: '0 32px',
      }
    : {
        minHeight: '82px',
        height: '82px',
        padding: isDesktop ? '26px 32px' : '26px 15px',
      };

  const trashCan = isOpen
    ? { opacity: 0, width: 0, height: 0 }
    : { width: '20px', height: '20px', minHeight: '20px' };

  const buttonStyle = isOpen
    ? { opacity: 0, width: 0, height: 0 }
    : { width: '30px', height: '30px', minHeight: '30px' };

  return (
    <Accordion
      expanded={isOpen}
      disableGutters
      sx={{
        p: 0,
        width: isDesktop ? '576px' : '100%',
        padding: isDesktop ? '0 85px' : '20px 15px',
        ml: isDesktop ? '-88px' : '0',
        borderRadius: '6px',
        backgroundColor: '#F8F8F8',
        position: 'relative',
        border: isOpen ? 'none' : '1px solid #00000014',
        boxShadow: 'none',
        '::before': {
          height: 0,
        },
      }}
    >
      <AccordionSummary
        style={{
          ...style,
        }}
        sx={{
          p: '0 12px !important',
        }}
      >
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <IconButton
            onClick={() => {
              setIsOpen(true);
              props.setCurrentOpenCard(props.index);
            }}
            sx={{ padding: 0 }}
            disableRipple
          >
            <Paper
              sx={{
                ...buttonStyle,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: `0px 2px 10px 0px #2D70D91F`,
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all',
                transitionDuration: '200ms',
              }}
            >
              <Avatar
                src={Add}
                alt={Dictionary[DICTIONARY.GENERAL].open}
                sx={{
                  ...buttonStyle,
                  transition: 'height, width',
                  transitionDuration: '100ms',
                }}
              />
            </Paper>
          </IconButton>
          <Typography> {!isOpen && props.text}</Typography>
          <IconButton sx={{ padding: 0 }} onClick={props.remove}>
            <Avatar
              src={TrashCan}
              alt={Dictionary[DICTIONARY.GENERAL].delete}
              sx={{
                ...trashCan,
                transition: 'all',
                transitionDuration: '200ms',
              }}
            />
          </IconButton>
        </Stack>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          p: 0,
        }}
      >
        <Paper
          variant='outlined'
          sx={{
            width: isDesktop ? '580px' : '100%',
            padding: isDesktop ? '32px 85px' : '20px 15px',
            ml: isDesktop ? '-88px' : '0',
            borderRadius: '8px',
            backgroundColor: '#F8F8F8',
            position: 'relative',
            border: isDesktop ? '1px solid #00000014' : 'none',
            boxShadow: 'none',
            bgcolor: '#F8F8F8',
          }}
        >
          <IconButton
            onClick={() => {
              setIsOpen(false);
              props.setCurrentOpenCard(props.index);
            }}
            sx={{
              position: 'absolute',
              top: '26px',
              padding: '0',
              left: isDesktop ? '32px' : 'unset',
            }}
          >
            <Paper
              sx={{
                width: '30px',
                height: '30px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: `0px 2px 10px 0px #2D70D91F`,
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            >
              <Avatar
                alt={Dictionary[DICTIONARY.GENERAL].close}
                src={Shrink}
                sx={{ width: '12px', height: '1.5px' }}
              />
            </Paper>
          </IconButton>
          {props.children}
          {props.index > 0 && <TrashCanGrid remove={props.remove} />}
        </Paper>
      </AccordionDetails>
    </Accordion>
  );
};
